
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { VenueRecommendation } from "./types";
import { VenueCard } from "./VenueCard";

interface VenueRecommendationListProps {
  recommendations: VenueRecommendation[];
  selectedId: string | null;
  onSelect: (id: string) => void;
}

export const VenueRecommendationList = ({
  recommendations,
  selectedId,
  onSelect
}: VenueRecommendationListProps) => {
  return (
    <div className="space-y-4 px-4">
      <h3 className="text-sm font-light">Where</h3>
      <Carousel className="w-full overflow-visible">
        <CarouselContent className="py-2">
          {recommendations.map(rec => (
            <CarouselItem 
              key={rec.recommendation_id} 
              className="md:basis-1/2 lg:basis-1/3 basis-[85%] pr-4"
            >
              <VenueCard 
                recommendation={rec} 
                isSelected={selectedId === rec.recommendation_id} 
                onClick={() => onSelect(rec.recommendation_id)} 
              />
            </CarouselItem>
          ))}
        </CarouselContent>
        <CarouselPrevious className="hidden md:flex -left-4" />
        <CarouselNext className="hidden md:flex -right-4" />
      </Carousel>
    </div>
  );
};
